import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { ItemPricingModel } from 'products-data';
import { ItemPriceSaleAndFeesInfoViewComponent } from '../../../item-price-sale-and-fees-info/views/item-price-sale-and-fees-info-view/item-price-sale-and-fees-info-view.component';
import { ItemPriceSaleAndFeesInfoButtonViewLocalization } from './item-price-sale-and-fees-info-button-view-localization';

@Component({
  selector: 'ideal-item-price-sale-and-fees-info-button-view',
  imports: [MatButtonModule, MatMenuModule, ItemPriceSaleAndFeesInfoViewComponent],
  standalone: true,
  templateUrl: './item-price-sale-and-fees-info-button-view.component.html',
  styleUrl: './item-price-sale-and-fees-info-button-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemPriceSaleAndFeesInfoButtonViewComponent {
  protected readonly localization = ItemPriceSaleAndFeesInfoButtonViewLocalization;

  public readonly pricing = input<ItemPricingModel>();
  public readonly multiplyBy = input(1);

  protected readonly hasFees = computed(() => (this.pricing()?.fees.length ?? 0) > 0);
  protected readonly isLimitedSale = computed(() => this.pricing()?.isOnSaleLimited ?? false);

  protected readonly notice = computed(() => {
    const hasFees = this.hasFees();
    const isLimitedSale = this.isLimitedSale();
    if (hasFees && isLimitedSale) {
      return this.localization.limitedTimeAndFeesNotice;
    } else if (hasFees) {
      return this.localization.feesNotice;
    } else if (isLimitedSale) {
      return this.localization.limitedTimeNotice;
    }
    return '';
  });
}
